import { createMuiTheme } from '@material-ui/core';

// https://material-ui-next.com/customization/themes/#typography

export const theme = createMuiTheme({
    typography: {
        fontFamily:
            '"Source Sans Pro", -apple-system, system-ui, BlinkMacSystemFont, Roboto, "Segoe UI", Segoe, Arial, sans-serif',
        button: {
            textTransform: null as any,
        },
    },
    overrides: {
        MuiInput: {
            root: {
                alignItems: 'center',
            },
        },
    },
});
